import Wordmark from "@/sections/Wordmark";
import { Link } from "react-router-dom";

const columns = [
    {
        title: "Product",
        links: [
            { label: "Platform", to: "/#platform", hash: true },
            { label: "Agents", to: "/#agents", hash: true },
            { label: "Practice areas", to: "/#practice", hash: true },
            { label: "Pricing", to: "/pricing" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "About", to: "/about" },
            { label: "Contact", to: "/contact" },
            { label: "Book a demo", href: "https://calendly.com/d/d3nd-zhb-2fr/lexafide-demo-discussion-30-minute-meeting-web", external: true },
        ],
    },
    {
        title: "Legal",
        links: [
            { label: "Terms of Service", to: "/terms" },
            { label: "Privacy Policy", to: "/privacy" },
            { label: "Cookie Policy", to: "/cookies" },
            { label: "Data Request", href: "https://app.termly.io/dsar/7191c046-a603-4b80-bd49-81a01b24251e", external: true },
        ],
    },
];

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-[var(--border)] bg-[var(--cream-2)] pt-16 md:pt-20 pb-10"
        >
            <div className="max-w-[1280px] mx-auto px-6 md:px-10">
                {/* Top: brand + columns */}
                <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 md:gap-12 pb-12 border-b border-[var(--border)]">
                    {/* Brand */}
                    <div className="flex flex-col gap-5 max-w-sm">
                        <Link to="/" data-testid="footer-logo" className="inline-flex">
                            <Wordmark />
                        </Link>
                        <p className="text-[14.5px] text-[var(--ink-soft)] leading-relaxed">
                            AI agents for legal operations — built for personal injury, mass tort, and high-volume plaintiff firms.
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[var(--ink-dim)]">
                                SOC 2 · HIPAA-aligned
                            </span>
                        </div>
                    </div>

                    {/* Link columns */}
                    {columns.map((col) => (
                        <div key={col.title} data-testid={`footer-col-${col.title.toLowerCase()}`}>
                            <h4 className="font-mono text-[11px] tracking-[0.22em] uppercase text-[var(--ink-dim)] mb-5">
                                {col.title}
                            </h4>
                            <ul className="space-y-3">
                                {col.links.map((link) => (
                                    <li key={link.label}>
                                        {link.href ? (
                                            <a
                                                href={link.href}
                                                target={link.external ? "_blank" : undefined}
                                                rel={link.external ? "noopener noreferrer" : undefined}
                                                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                                                className="text-[14.5px] text-[var(--ink-soft)] hover:text-[var(--ink)] transition-colors inline-flex items-center gap-2"
                                            >
                                                {link.label}
                                                {link.external && (
                                                    <i className="fa-solid fa-arrow-up-right-from-square text-[9px] text-[var(--ink-dim)]" />
                                                )}
                                            </a>
                                        ) : (
                                            <Link
                                                to={link.to}
                                                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                                                className="text-[14.5px] text-[var(--ink-soft)] hover:text-[var(--ink)] transition-colors"
                                            >
                                                {link.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Bottom: copyright + tagline */}
                <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs font-mono text-[var(--ink-dim)] tracking-[0.05em]">
                    <div className="flex items-center gap-3">
                        <span>© {year} Lexafide, Inc.</span>
                        <span className="hidden md:inline">·</span>
                        <span className="hidden md:inline">All rights reserved.</span>
                    </div>
                    <div className="flex items-center gap-4">
                        <Link to="/terms" className="hover:text-[var(--ink)] transition-colors">Terms</Link>
                        <Link to="/privacy" className="hover:text-[var(--ink)] transition-colors">Privacy</Link>
                        <Link to="/cookies" className="hover:text-[var(--ink)] transition-colors">Cookies</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
